import { captureMessage } from '@lib/sentry'
import { configure } from 'mobx'

interface ForeignMobxGlobals {
  version?: number
}

interface GlobalWithMobxState {
  __mobxInstanceCount?: number
  __mobxGlobals?: ForeignMobxGlobals
}

const getGlobalMobxState = (): GlobalWithMobxState => globalThis as unknown as GlobalWithMobxState

// Neutralises a foreign, page-injected MobX (Sentry ADMIN-1) so it can never
// collide with our bundled MobX. This is configuration, not state management.
export const isolateMobxGlobalState = (): void => {
  const state = getGlobalMobxState()
  const instanceCount = state.__mobxInstanceCount ?? 0
  const foreignGlobals = state.__mobxGlobals

  if (instanceCount > 1 || (foreignGlobals !== undefined && foreignGlobals.version !== 6)) {
    captureMessage(
      `Foreign MobX detected before isolation (instanceCount=${instanceCount}, version=${foreignGlobals?.version})`,
      'warning',
    )
  }

  configure({ isolateGlobalState: true })
}
